import React, { useState } from "react";
import styled from "styled-components";

import { isUserRole } from "@examspark/common";
import {
  ClassroomTableList,
  useAppContext,
  useQueryGetUserClassrooms,
} from "@examspark/common-app";
import {
  Button,
  Text,
  TextInput,
  ToggleButtonGroup,
  Toolbar,
} from "@examspark/common-ui";
import { IconRefreshLine } from "@examspark/common-ui/dist/components/icons";
import { WorkspaceUserRole } from "@examspark/types";

import Breadcrumbs from "../common/Breadcrumbs";
import Loading from "../common/Loading";
import PageSectionSpacing from "../common/PageSectionSpacing";

import ClassroomsGrid from "./ClassroomsGrid";
import ClassroomsSetupPrompt from "./ClassroomsSetupPrompt";

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Classrooms = () => {
  const [state] = useAppContext();
  const [tab, setTab] = useState("mine");
  const [filterName, setFilterName] = useState("");
  const { data: classrooms } = useQueryGetUserClassrooms(
    state.workspaceUser?.id,
    state.user?.id,
  );

  const { data: allClassrooms, refetch: refetchAll } =
    useQueryGetUserClassrooms(
      state.workspaceUser?.id,
      state.user?.id,
      isUserRole(state.workspaceUser, WorkspaceUserRole.ContentManager),
    );

  const { data: myArchivedClassrooms } = useQueryGetUserClassrooms(
    state.workspaceUser?.id,
    state.user?.id,
    false,
    {
      filter: {
        status: "archived",
      },
    },
  );

  return (
    <PageSectionSpacing>
      <PageLayout>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <Text.H1>Classrooms</Text.H1>
      </PageLayout>
      <Toolbar>
        <ToggleButtonGroup
          color="light-gray"
          value={tab}
          onClick={(value) => {
            setTab(value);
          }}
        >
          <ToggleButtonGroup.Button value="mine">
            My Classrooms
          </ToggleButtonGroup.Button>
          <ToggleButtonGroup.Button value="all">
            All Classrooms
          </ToggleButtonGroup.Button>
        </ToggleButtonGroup>
      </Toolbar>
      {tab === "mine" ? (
        <>
          {classrooms == null && <Loading>Loading Classrooms</Loading>}
          {classrooms != null && !classrooms?.length && (
            <ClassroomsSetupPrompt />
          )}
          {classrooms != null && !!classrooms.length && (
            <ClassroomsGrid sections={classrooms} />
          )}
          {myArchivedClassrooms != null && !!myArchivedClassrooms.length && (
            <>
              <h3>My Archived Classrooms</h3>
              <ClassroomTableList items={myArchivedClassrooms} />
            </>
          )}
        </>
      ) : (
        <>
          <Toolbar>
            <TextInput
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
              style={{
                flex: "1",
              }}
              placeholder={"Filter Classrooms by Name..."}
              // disabled={!showStudentNames}
            />
            <Button
              title="Reload"
              // isLoading={isFetching}
              variant="outlined"
              onClick={(e) => {
                if (e.altKey) {
                  e.stopPropagation();
                  // console.log({ props.config });
                  return;
                }
                refetchAll();
              }}
              icon={
                <div style={{ width: "16px", height: "16px" }}>
                  <IconRefreshLine width="14" />
                </div>
              }
            >
              Refresh
            </Button>
          </Toolbar>
          <ClassroomTableList items={allClassrooms} filter={filterName} />
        </>
      )}
    </PageSectionSpacing>
  );
};

export default Classrooms;
